import { useEffect, useState } from "react";
import { Truck } from "lucide-react";
import { api } from "@/lib/api";

const DEFAULT_TEXT = "Summer Sale - Up to 50% Off Selected Styles";

export const AnnouncementBar = () => {
  const [text, setText] = useState(DEFAULT_TEXT);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    api.get("/settings")
      .then(({ data }) => {
        if (data.announcement_text !== undefined) setText((data.announcement_text || "").trim());
      })
      .catch(() => {});
  }, []);

  const sale = text ? (
    <span data-testid="announcement-text">
      <span className="text-gold-bright">✦</span> {text} <span className="text-gold-bright">✦</span>
    </span>
  ) : null;
  const delivery = (
    <span className="flex items-center gap-2" data-testid="announcement-delivery">
      <Truck className="w-3.5 h-3.5" /> Free UK delivery on orders over £40
    </span>
  );

  // Messages that rotate on mobile (skip the sale slide when there is no text).
  const mobileMessages = [sale, delivery].filter(Boolean);

  useEffect(() => {
    if (mobileMessages.length <= 1) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % mobileMessages.length), 3500);
    return () => clearInterval(t);
  }, [mobileMessages.length]);

  return (
    <div
      className="bg-berry text-white text-[11px] sm:text-xs font-sans tracking-[0.2em] uppercase"
      data-testid="announcement-bar"
    >
      {/* Desktop: the sale text (when set) and the delivery message, side by side */}
      <div className="hidden sm:flex max-w-[1800px] mx-auto px-4 py-2.5 items-center justify-center gap-x-12 text-center">
        {sale}
        {delivery}
      </div>

      {/* Mobile: cycle through all messages (fixed height so rotating never shifts the page) */}
      <div className="sm:hidden px-4 h-11 flex items-center justify-center text-center overflow-hidden">
        <span key={idx} className="animate-fade-in leading-tight line-clamp-2">{mobileMessages[idx % mobileMessages.length]}</span>
      </div>
    </div>
  );
};
